<!--
  Copyright 2022 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->
<div *ngIf="auth.getUser$() | async as user">
  <div *ngIf="user.isAuthenticated">
    <button mat-icon-button (click)="openProfileDialog($event)">
      <img
        *ngIf="user.photoURL; else showDefaultPhoto"
        referrerpolicy="no-referrer"
        src="{{ user.photoURL }}=s32"
        class="user-thumb"
      />
      <ng-template #showDefaultPhoto>
        <user-avatar
          [displayText]="user.displayName?.charAt(0)"
        ></user-avatar>
      </ng-template>
    </button>
  </div>
</div>
